import type { ResponseDto } from '@app/api/dtos'
import type { MonitoringValidationConfigStoresLinksDto } from '@app/api/routes/monitoringValidation/dtos'
import type { MonitoringValidationConfigStoresLinksDataSource } from '@app/types/dataSource'

export const getMonitoringValidationConfigStoresLinksDataFromResponse = (
  response?: ResponseDto<MonitoringValidationConfigStoresLinksDto>
): MonitoringValidationConfigStoresLinksDataSource[] | undefined => {
  if (!response) return

  const rawData: MonitoringValidationConfigStoresLinksDto[] | undefined = response?.results

  if (!rawData) return

  return rawData.map(dto => ({
    key: dto.id,
    firstCompetitorId: dto?.firstCompetitorId ?? null,
    secondCompetitorId: dto?.secondCompetitorId ?? null
  }))
}
